import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@material-ui/core';
import messages from '../messages';
export const NoOptionsMessage = props => /*#__PURE__*/React.createElement(Typography, _extends({
  color: "textSecondary",
  className: props.selectProps.classes.noOptionsMessage
}, props.innerProps), /*#__PURE__*/React.createElement(FormattedMessage, messages.noOpts));